const ShowAllSymbolsActionId = 'workbench.action.showAllSymbols';
export { ShowAllSymbolsActionId };
